import { makeStyles } from "@material-ui/core/styles";

export default makeStyles({
  generalInfoTable: {
    marginBottom: 28
  },
  loader: {
    alignItems: "start",
    marginTop: 80
  }
});
